import { ComponentProps } from 'react';
import { Badge } from '../../../../../design-system/badge/badge';
import { InvoiceStatusLabel } from './get-invoice-status-label';

type BadgeVariant = Extract<ComponentProps<typeof Badge>['variant'], 'neutral' | 'negative' | 'positive' | 'attention'>;

export const getBadgeVariant = (status: InvoiceStatusLabel): BadgeVariant => {
  if (status === 'Paid') {
    return 'positive';
  }

  if (status === 'Due soon') {
    return 'attention';
  }

  if (status === 'Overdue') {
    return 'negative';
  }

  return 'neutral';
};
